import React from "react";
import { TextInput } from "@narmi/design_system";

export function checkConstraints(image, file, constraints) {
  if (
    image.width > constraints.max_width ||
    image.height > constraints.max_height ||
    image.width < constraints.min_width ||
    image.height < constraints.min_height ||
    file.size > constraints.size
  ) {
    return false;
  }
  return true;
}

export function ImageUploadInput({
  defaultValue,
  onChange,
  error,
  attemptedValue,
  constraints,
  backgroundColor,
}) {
  const [errorMsg, setErrorMsg] = React.useState(error);
  const [value, setValue] = React.useState(
    error && attemptedValue != null ? attemptedValue : defaultValue
  );

  const subChange = async (e) => {
    if (e != null) {
      const img = document.createElement("img");
      const file = e.target.files[0];

      if (!constraints.allowed_types.includes(file.type)) {
        // Convert MIME types to user-friendly file extensions
        const mimeToExtensionMap = {
          "image/bmp": ".bmp",
          "image/jpeg": ".jpg",
          "image/pjpeg": ".jpg",
          "image/png": ".png",
          "image/svg+xml": ".svg",
          "image/tiff": ".tiff",
          "image/x-tiff": ".tiff",
          "image/x-icon": ".ico",
          "image/vnd.microsoft.icon": ".ico",
        };

        const allowedExtensions = constraints.allowed_types.map(
          (mimeType) => mimeToExtensionMap[mimeType] || mimeType
        );

        setErrorMsg(`Invalid file type. Only ${allowedExtensions.join(", ")} files are allowed.`);
        return;
      }

      img.src = URL.createObjectURL(file);
      img.onload = () => {
        if (!checkConstraints(img, file, constraints)) {
          const sizeInMBs = constraints.max_content_length / 10 ** 6;
          setErrorMsg(
            `Image dimensions/size invalid. Valid dimensions ${constraints.min_width}-${constraints.max_width}x${constraints.min_height}-${constraints.max_height}. Valid file size: ${sizeInMBs} MBs`
          );
        } else {
          setErrorMsg("");
          setValue(img.src);
          onChange(img.src);
        }
      };
    }
  };
  return (
    <div>
      <input type="hidden" name="setting_value" id="setting_value" />
      <TextInput
        type="file"
        onChange={subChange}
        name="setting_image_preview"
        id="setting_image_preview"
        accept={constraints.allowed_types}
        error={errorMsg}
      />
      {value && <img src={value} alt="logo_img" id="image_value" style={{ backgroundColor }} />}
    </div>
  );
}

export default ImageUploadInput;
